export default __webpack_public_path__ + "deepseek1e938c.png";